import { temporarilyNotSupport } from '../../utils'

// 性能
export const reportPerformance = /* @__PURE__ */ temporarilyNotSupport('reportPerformance')
export const getPerformance = /* @__PURE__ */ temporarilyNotSupport('getPerformance')
export const preloadWebview = /* @__PURE__ */ temporarilyNotSupport('preloadWebview')
export const preloadSkylineView = /* @__PURE__ */ temporarilyNotSupport('preloadSkylineView')
export const preloadAssets = /* @__PURE__ */ temporarilyNotSupport('preloadAssets')
